import { useEffect, useState } from "react";
import { BellRing, X } from "lucide-react";
import {
  subscribeBookingAlerts,
  clearAllBookingAlerts,
} from "../lib/bookingAlertManager";

/**
 * Floating fixed banner shown at the top while any new_booking alert is
 * unacknowledged. Stops sonnerie loop when user clicks "Arrêter".
 */
export default function BookingAlertBanner() {
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    const unsub = subscribeBookingAlerts((next) => setAlerts(next));
    return () => unsub();
  }, []);

  if (alerts.length === 0) return null;

  const latest = alerts[alerts.length - 1];

  return (
    <div
      className="fixed top-4 left-1/2 -translate-x-1/2 z-[60] w-[92%] sm:w-auto sm:min-w-[420px] max-w-[560px] bg-[#EF4444] text-white rounded-2xl shadow-2xl border-2 border-white/20 animate-in slide-in-from-top-3"
      data-testid="booking-alert-banner"
      role="alert"
    >
      <div className="flex items-center gap-3 px-4 py-3">
        <div className="shrink-0 w-10 h-10 rounded-full bg-white/15 flex items-center justify-center animate-pulse">
          <BellRing className="w-5 h-5" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-bold leading-tight" style={{ fontFamily: "Outfit" }}>
            {alerts.length === 1
              ? "Nouvelle réservation à traiter"
              : `${alerts.length} réservations à traiter`}
          </p>
          <p className="text-xs text-white/90 truncate">
            {latest.message || "Acceptez ou refusez pour arrêter la sonnerie"}
          </p>
        </div>
        <button
          onClick={() => clearAllBookingAlerts()}
          className="shrink-0 px-3 py-1.5 rounded-full bg-white text-[#EF4444] text-xs font-bold hover:bg-white/90 transition-colors flex items-center gap-1"
          data-testid="booking-alert-stop-btn"
          aria-label="Arrêter la sonnerie"
        >
          <X className="w-3.5 h-3.5" /> Arrêter
        </button>
      </div>
    </div>
  );
}
